import React, { createRef, useContext, useEffect, useState } from 'react'
import { AppContext } from '../context/AppContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { CONFIG } from '../config/general';
import ThemeToggle from './ThemeToggle';

const Header = () => {
  const { login, setLogin, appData } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation()

  const handleLogout = () => {
    setLogin({ ...login, isLogin: false, token: null });
    localStorage.removeItem("token")
    localStorage.removeItem("userData")
    navigate('/');
  };

  const findPage = () => {
    if (location.pathname === "/") {
      document.title = "Home | Prabhu Chat"
      return "Home"
    }
    if (location.pathname === "/login") {
      document.title = "Login | Prabhu Chat"
      return "Login"
    }
    if (location.pathname === "/users") {
      document.title = "Users | Prabhu Chat"
      return "Users"
    }
    if (location.pathname === "/groups") {
      document.title = "Groups | Prabhu Chat"
      return "Groups"
    }
    if (location.pathname === "/tracker") {
      document.title = "Tracker | Prabhu Chat"
      return "Tracker"
    }
    if (location.pathname === "/settings") {
      document.title = "Settings | Prabhu Chat"
      return "Settings"
    }
    if (location.pathname === "/config-settings") {
      document.title = "Configuration | Prabhu Chat"
      return "Configuration"
    }
    if (location.pathname === "/department") {
      document.title = "Department | Prabhu Chat"
      return "Department"
    }
    if (location.pathname.includes("viewUser")) {
      document.title = "View User | Prabhu Chat"
      return "User"
    }
    if (location.pathname.includes("screenshot")) {
      document.title = "Screenshots | Prabhu Chat"
      return "Screenshots"
    }
    if (location.pathname.includes("chat")) {
      document.title = "Chat | Prabhu Chat"
      return "Chat"
    }
    if (location.pathname.includes("screen-sharing")) {
      document.title = "Screen Sharing | Prabhu Chat"
      return "Screen Sharing"
    }
    if (location.pathname.includes("warnings")) {
      document.title = "Warnings | Prabhu Chat"
      return "Warnings"
    }
  }

  useEffect(() => {
    if (appData.expired && login.isLogin) {
      handleLogout()
    }
  }, [])

  return (
    <div>
      <header>
        <div className="siteHeader d_flex flex-wrap">
          <div className="headerWrap">
            <nav style={{ "--bs-breadcrumb-divider": "'>';" }} aria-label="breadcrumb">
              <ol className="breadcrumb m-0 ms-lg-4">
                <li className="breadcrumb-item fs-18"><a href="#">Admin</a></li>
                <li className="breadcrumb-item active fs-18" aria-current="page">{findPage()}</li>
              </ol>
            </nav>
          </div>
          {login.isLogin ? <div className="headerWrap">
            <ThemeToggle />
            <a className="notification main-tooltip" href="#">
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="18" cy="18" r="18" fill="#EBEFFF" />
                <path d="M24.1167 20.0751L23.2833 18.6917C23.1083 18.3834 22.95 17.8001 22.95 17.4584V15.3501C22.95 13.3917 21.8 11.7001 20.1417 10.9084C19.7083 10.1417 18.9083 9.66675 17.9917 9.66675C17.0833 9.66675 16.2667 10.1584 15.8333 10.9334C14.2083 11.7417 13.0833 13.4167 13.0833 15.3501V17.4584C13.0833 17.8001 12.925 18.3834 12.75 18.6834L11.9083 20.0751C11.575 20.6334 11.5 21.2501 11.7083 21.8167C11.9083 22.3751 12.3833 22.8084 13 23.0167C14.6167 23.5667 16.3167 23.8334 18.0167 23.8334C19.7167 23.8334 21.4167 23.5667 23.0333 23.0251C23.6167 22.8334 24.0667 22.3917 24.2833 21.8167C24.5 21.2417 24.4417 20.6084 24.1167 20.0751Z" fill="#1edd60" />
                <path d="M20.3584 24.6751C20.0084 25.6417 19.0834 26.3334 18 26.3334C17.3417 26.3334 16.6917 26.0667 16.2334 25.5917C15.9667 25.3417 15.7667 25.0084 15.65 24.6667C15.7584 24.6834 15.8667 24.6917 15.9834 24.7084C16.175 24.7334 16.375 24.7584 16.575 24.7751C17.05 24.8167 17.5334 24.8417 18.0167 24.8417C18.4917 24.8417 18.9667 24.8167 19.4334 24.7751C19.6084 24.7584 19.7834 24.7501 19.95 24.7251C20.0834 24.7084 20.2167 24.6917 20.3584 24.6751Z" fill="#1edd60" />
                <circle cx="31" cy="5" r="4" fill="#FA3E3E" />
              </svg>
              <span className="tooltip">Coming Soon</span>
            </a>
            <div className="userName d-flex flex-wrap">
              <img
                src={CONFIG.REACT_APP_UPLOADS + "/Icons/logo.png"}
                alt="Profile Pic"
                onError={(e) => {
                  e.target.onerror = null; // Prevents infinite loop if the fallback also fails
                  e.target.src = "./assets/images/logo.png"; // Set the fallback image
                }}
                className="px-4"
                style={{ width: "100px", borderRadius: "50%" }}
              />
              <div className="dropdown">
                <button className="btn btn-secondary dropdown-toggle fs-18" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  {login?.user?.name}
                </button>
                <ul className="dropdown-menu">
                  <li><a className="dropdown-item" href="#/">Dashboard</a></li>
                  {window.electronAPI?.isElectron && <li><a className="dropdown-item" href="#/config-settings">Config Settings</a></li>}
                  <li><a className="dropdown-item" onClick={handleLogout}>Logout</a></li>
                </ul>
              </div>
            </div>
          </div> : <>
            <div><a className="dropdown-item" href="#/login">Login</a></div>
            {window.electronAPI?.isElectron && <div><a className="dropdown-item" href="#/config-settings">Configuration</a></div>}
          </>}
        </div>
      </header>
    </div>
  )
}

export default Header
